import { useState, createContext, useEffect } from "react";

export const AlignmentContext = createContext<any>(null);

const AlignmentProvider = ({ children }: any) => {
	const [alignment, setAlignment] = useState<string>("city");
	useEffect(() => {
		//console.log(alignment);
	}, [alignment]);

	return (
		<AlignmentContext.Provider value={{ alignment, setAlignment }}>
			{children}
		</AlignmentContext.Provider>
	);
};

export default AlignmentProvider;
